

export default class BrazeConstants {

    static get USER_ATTRIBUTES(){
        return {'showtime_bundle' : 'showtime bundle'}
    }

    static get PLAN_TYPES(){
        return {
            cf: {
                0: 'CF_ANNUAL',
                1: 'CF_MONTHLY'
            },
            lc: {
                0: 'LC_ANNUAL',
                1: 'LC_MONTHLY'
            },
            lcp: {
                0: 'LCP_ANNUAL',
                1: 'LCP_MONTHLY'
            },
        }
    }

};

